import API from './jsonapi-constants'

export const CONSTANTS = {
  ATTRIBUTE: {
    ADDRESS1: 'customer.address.address1',
    ADDRESS2: 'customer.address.address2',
    ADDRESS3: 'customer.address.address3',
    CITY: 'customer.address.city',
    COMPANY: 'customer.address.company',
    COUNTRYID: 'customer.address.countryid',
    EMAIL: 'customer.address.email',
    FIRSTNAME: 'customer.address.firstname',
    ID: 'customer.address.id',
    LANGUAGEID: 'customer.address.languageid',
    LASTNAME: 'customer.address.lastname',
    LATITUDE: 'customer.address.latitude',
    LONGITUDE: 'customer.address.longitude',
    POSITION: 'customer.address.position',
    POSTAL: 'customer.address.postal',
    SALUTATION: 'customer.address.salutation',
    STATE: 'customer.address.state',
    TELEFAX: 'customer.address.telefax',
    TELEPHONE: 'customer.address.telephone',
    TITLE: 'customer.address.title',
    VATID: 'customer.address.vatid',
    WEBSITE: 'customer.address.website',
    SAP_ADDRESS_ID: 'sap_address_id',
    BAAN_ADDRESS_ID: 'baan_address_id',
    CONTACT_PERSON: 'contact_person',
  },
}

export const PATHS = {
  ADDRESS1: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS1],
  ADDRESS2: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS2],
  ADDRESS3: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS3],
  CITY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CITY],
  COMPANY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COMPANY],
  COUNTRYID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COUNTRYID],
  EMAIL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.EMAIL],
  FIRSTNAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.FIRSTNAME],
  ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ID],
  LANGUAGEID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LANGUAGEID],
  LASTNAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LASTNAME],
  LATITUDE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LATITUDE],
  LONGITUDE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LONGITUDE],
  POSITION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.POSITION],
  POSTAL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.POSTAL],
  SALUTATION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.SALUTATION],
  STATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATE],
  TELEFAX: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TELEFAX],
  TELEPHONE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TELEPHONE],
  TITLE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TITLE],
  VATID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.VATID],
  WEBSITE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.WEBSITE],
  SAP_ADDRESS_ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.SAP_ADDRESS_ID],
  BAAN_ADDRESS_ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.BAAN_ADDRESS_ID],
  CONTACT_PERSON: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CONTACT_PERSON],
}

export default {
  CONSTANTS,
  PATHS,
}
